import React from 'react';
import './index.scss';
import Button from 'elements/button';

export default function index() {
  return (
    <Button href="/" className="logo" type="link">
      Kerabat<span>Motret</span>
    </Button>
  );
}
